import { useQuery } from "@tanstack/react-query";
import { NOTE_KEYS } from "./note.keys";
import { noteServices } from "./note.services";
import { GetNoteParams } from "./note.types";

export const useGetNotes = (params?: GetNoteParams) => {
  return useQuery({
    queryKey: NOTE_KEYS.GET_NOTES(params),
    queryFn: () => noteServices.getNotes(params),
  });
};
